import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SiteAdmin from '../components/SiteAdmin';
import Page from '../../../components/Page';
import ServiceRequestList from '../components/ServiceRequestList';
import { ServiceRequestAPI } from '../../../api';
import withAdminOnly from '../components/AdminOnly';

const useStyles = makeStyles({
  title: {
    marginBottom: '2rem',
  },
});

const ServiceRequestAdminPage = () => {
  const [data, setData] = React.useState(null);
  const classes = useStyles();

  const getData = async () => {
    try {
      const { payload } = await ServiceRequestAPI.adminListRequests();
      setData(payload);
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }
  };

  React.useEffect(() => {
    getData();
  }, []);  // eslint-disable-line

  return (
    <Page title="Provider Admin">
      <SiteAdmin>
        <Typography variant="h6" color="primary" className={classes.title}>Service Request Admin</Typography>
        <ServiceRequestList
          data={data}
        />
      </SiteAdmin>
    </Page>
  );
};

export default withAdminOnly(ServiceRequestAdminPage);
